export const {
  ReadableStream,
  ReadableStreamDefaultReader,
  // @ts-ignore
  ReadableStreamBYOBReader,
  // @ts-ignore
  ReadableStreamBYOBRequest,
  // @ts-ignore
  ReadableByteStreamController,
  ReadableStreamDefaultController,
  TransformStream,
  TransformStreamDefaultController,
  WritableStream,
  WritableStreamDefaultWriter,
  WritableStreamDefaultController,
  ByteLengthQueuingStrategy,
  CountQueuingStrategy,
  TextEncoderStream,
  TextDecoderStream,
} = globalThis
